import { i18n } from 'src/boot/i18n';
const { t, te } = i18n.global;
export const getApiErrorMessage = (code: string): string => {
  if (te(`error.${code}`)) {
    return t(`error.${code}`);
  } else {
    return t('error.unknown');
  }
};
